
import React from "react";
import { useNavigate } from "react-router-dom";

type LoaderProps = { loading: boolean; };
type ErrorProps = { error: string | null; courseError?: string | null; };

export function Loader({ loading }: LoaderProps) {
  if (!loading) return null;
  return (
    <div className="flex justify-center items-center min-h-[400px]">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
    </div>
  );
}

export function CheckoutError({ error, courseError }: ErrorProps) {
  const navigate = useNavigate();
  return (
    <div className="container max-w-4xl mx-auto py-12 px-4">
      <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
        <h2 className="text-xl font-semibold text-red-800 mb-2">Viga</h2>
        <p className="text-red-700">{error || courseError || "Kursust ei leitud"}</p>
        <button 
          onClick={() => navigate('/courses')}
          className="mt-4 px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90"
        >
          Tagasi kursuste juurde
        </button>
      </div>
    </div>
  );
}
